module.exports = __webpack_public_path__ + "static/media/Esri_Word_Imagery.1850db9b.png";